module.exports = __webpack_public_path__ + "static/media/24UHCHR20.04943c97.jpg";